import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    margin-bottom: 20px;
`;

export const LayerSelect = styled.select`
    flex: 1;
    margin-right: 5px;
    border: 1px solid #555;
    background-color: #111;
    height: 30px;
    padding: 0 5px;
    color: #999;

    &:focus {
        outline: none;
    }
`;

export const LayerInput = styled.input`
    flex: 1;
    border: 1px solid #333;
    background-color: transparent;
    height: 30px;
    color: #fff;
    padding-left: 5px;
    margin-right: 5px;

    &:focus {
        outline: none;
    }
`;

export const Button = styled.div.attrs(props => ({
    style: props.width ? {
        width: props.width
    } : {
        flex: 1
    }
}))`
    height: 30px;
    background-color: transparent;
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    transition: all .4s ease 0s;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 16px;

    ${props => props.icon ? `&:before {
        content: '${props.icon}';
        font-family: "Material Design Icons";
    }` : ''}

    :hover {
        background-color: ${props => props.color};
        color: #000;
    }

    &:not(:first-child) {
        margin-left: 10px;
    }
`;

export const RemoveGroup = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const RemoveRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    font-size: 12px;
`;

export const RemoveDesc = styled.div`
    width: 100%;
    color: #888;
    font-size: 14px;
    margin-top: 10px;
`;

export const RemoveTitle = styled.div`
    flex: 1;
    color: #fff;
    font-size: 14px;
`;